<template>
  <main class="">
    <div class="table-container">
      <MembersTable
        v-if="dealroomWaitlist && dealroomWaitlist.length !== 0"
        :tableHeaders="tableHeaders"
        :tableRows="tableRows"
        :columnNumber="tableHeaders.length - 2"
        :columnWidth="200"
        :totalPage="pages"
        :currentPage="page"
        :deals="tokens"
        @gotoPage="gotoPage"
        @update-members="fetchDealRoomWaitlist({ page, status })"
      />
      <EmptyState v-if="!dealroomWaitlist || dealroomWaitlist.length === 0">
        <template v-slot:message>
          <div class="tw-text-center tw-text-gray tw-my-3">
            <p>There are no members on this waitlist.</p>
          </div>
        </template>
      </EmptyState>
    </div>
  </main>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import MembersTable from "@/components/tables/MembersTable";
  import EmptyState from "@/components/notification/EmptyState";
  import { formatISOTime, formatISODate, truncate } from "@/utils/helpers.js";
  export default {
    name: "Waitlist",
    data() {
      return {
        tableHeaders: [
          "Name",
          "Email",
          "Date Joined",
          "Status",
          "Action",
          "id",
        ],
        tableRows: [],
        page: 1,
        pages: 0,
      };
    },
    components: { MembersTable, EmptyState },
    computed: {
      ...mapGetters("TokenModule", ["dealroomWaitlist"]),
      ...mapGetters("organisationModule", ["tokens"]),
    },
    created() {
      this.fetchDealRoomWaitlist();
    },
    watch: {
      dealroomWaitlist: "updateTableRow",
    },
    methods: {
      ...mapActions("TokenModule", ["getDealRoomWaitlist"]),
      async fetchDealRoomWaitlist(query = { page: 1, limit: 10 }) {
        try {
          const response = await this.getDealRoomWaitlist(query);
          const { page, totalPages } = response.data.data;
          this.page = page;
          this.pages = totalPages;
        } catch (error) {
          return error;
        }
      },

      updateTableRow() {
        this.tableRows = this.dealroomWaitlist?.map((member) => {
          let name = "";
          let status = member.status;
          switch (status) {
            case "Inactive":
              status = "Deactivated";
              break;

            case "Pending_Approval":
              status = "Pending";
              break;
            default:
              break;
          }
          if (status == "Pending") {
            name = member.name;
          } else {
            name = `${member.user ? member.user.fname : member.fname} ${
              member.user ? member.user.lname : member.lname
            }`;
          }
          return {
            name: `<span class="tw-font-bold">${name}</span>`,
            email: truncate(
              member.user?.email ? member.user?.email : member.email,
              25
            ),
            joined: `${formatISODate(
              member.createdAt || member.date_joined
            )}  ${formatISOTime(member.createdAt || member.date_joined)}`,
            id: `data-id/${member.member_id ? member.member_id : member._id}/${
              member.user ? member.user._id : member._id
            }`,
            status: status,
          };
        });
      },

      gotoPage(page) {
        const query = { page: page, status: "" };
        this.fetchDealRoomWaitlist(query);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .table-container {
    overflow: auto;
  }
</style>
